(function (){
    'use strict';

    angular.module('app')
    .directive('sliderRange', sliderRange)
    sliderRange.$inject =  ['$timeout'];

    function sliderRange($timeout) {
        return {
            restrict: 'A',
            scope: {
                min: '=',
                max: '=',
                step: '=',
                values: '=',
            },
            link: function(scope, element, attrs) {
                noUiSlider.create(element[0], {
                    range: {
                        'min': scope.min,
                        'max': scope.max
                    },
                    start: [scope.values[0], scope.values[1]],
                    step: scope.step,
                    connect: true,
                    behaviour: 'tap-drag',
                    tooltips: false,
                    format: wNumb({
                        decimals: 0,
                    })
                });

                element[0].noUiSlider.on('update', function (values, handle) {
                    $timeout(function(){
                        scope.$apply(function () {
                            scope.values = values;
                        });
                    })
                });
            }
        };
    }
})();

